export const ajaxTimeout = 30000;
export const pagesWithoutLogin = ['/', '/err', '/imprint', '/privacy'];
export const maxResults = 3000;
export const allowedDomainsForSerialMail = [
  'joerg-lienert.ch',
  'senator-partners.de',
  'match-flix.de'
];
